import { NormalizedCacheObject } from 'apollo-cache-inmemory'
import { CachePersistor } from 'apollo-cache-persist-dev'
import type { ApolloPersistOptions } from 'apollo-cache-persist-dev/types'
import { CACHE_ALWAYS_ON_LOAD, CACHE_PERSIST_DEFAULTS } from './cacheDefaults'

type CallbackFunction = (() => void) | (() => Promise<void>)

export default class ApolloPersistor extends CachePersistor<NormalizedCacheObject> {
    constructor(options: ApolloPersistOptions<NormalizedCacheObject>) {
        super(options)
        this.writeEmptyCache()
    }

    writeEmptyCache(): void {
        this.cache.cache.writeData({
            data: {
                ...CACHE_ALWAYS_ON_LOAD,
                ...CACHE_PERSIST_DEFAULTS,
                dashboardReflowTrigger: Math.random(),
                pastSearches: [],
            },
        })
    }

    // TS4114: This member must have an 'override' modifier because it overrides a member in the base class 'CachePersistor<NormalizedCacheObject>'.
    // ts-expect-error FIXME (noImplicitOverride)
    async purge(preWriteCallback?: CallbackFunction): Promise<void> {
        this.pause()
        await super.purge() // clears localforage (IndexedDB) — the actual storage location
        // Reset the in-memory cache BEFORE resume(), otherwise the Trigger immediately
        // re-serializes all stale query data (can be 200kB+) back into IndexedDB.
        await this.cache.cache.reset()
        if (preWriteCallback) {
            await preWriteCallback()
        }
        this.writeEmptyCache()
        this.resume()
    }
}
